import React from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.css';
import { ModalBg } from '../globalStyles';

export default function Modal({ children, modalOpen, setModalOpen, scrollable = false }) {
  if (typeof document === 'undefined') return null;

  const overlayClass = modalOpen
    ? scrollable
      ? `${styles.modalActive} ${styles.modalActiveScrollable}`
      : styles.modalActive
    : styles.modal;
  const contentClass = modalOpen
    ? scrollable
      ? `${styles.modalContentActive} ${styles.modalContentScrollable}`
      : styles.modalContentActive
    : styles.modalContent;

  return createPortal(
    <div id="modalContainer" className={overlayClass} onClick={() => setModalOpen(false)}>
      <ModalBg id="modalBox" className={contentClass} onClick={e => e.stopPropagation()}>
        {children}
      </ModalBg>
    </div>,
    document.body
  );
}
